import { createActions } from 'reduxsauce';

import { REDUX_NAMESPACE, REDUXACTIONS_STRUCTURE } from './constants';

export const { Types, Creators } = createActions(REDUXACTIONS_STRUCTURE, { prefix: REDUX_NAMESPACE });
